/**
 * Deployment-errors service context. VITE_DEPLOYMENT_ERRORS_SERVICE: mock (default) | http.
 */
import { createContext, useContext, type ReactNode } from 'react'
import type { IDeploymentErrorsService } from './IDeploymentErrorsService.interface'
import { MockDeploymentErrorsService } from './MockDeploymentErrorsService'
import { HttpDeploymentErrorsService } from './HttpDeploymentErrorsService'

function resolveService(): IDeploymentErrorsService {
  const key = (import.meta.env.VITE_DEPLOYMENT_ERRORS_SERVICE as string | undefined) ?? 'mock'
  return key === 'http' ? new HttpDeploymentErrorsService() : new MockDeploymentErrorsService()
}

const defaultService = resolveService()
const DeploymentErrorsServiceContext = createContext<IDeploymentErrorsService>(defaultService)

export function DeploymentErrorsServiceProvider({ children, service }: { children: ReactNode; service?: IDeploymentErrorsService }) {
  return <DeploymentErrorsServiceContext.Provider value={service ?? defaultService}>{children}</DeploymentErrorsServiceContext.Provider>
}

export function useDeploymentErrorsService(): IDeploymentErrorsService {
  return useContext(DeploymentErrorsServiceContext)
}
